<div class="sidebar-container">
  <ul class="list-group harp-sidebar">
    <ng-template ngFor let-item [ngForOf]="sidebarItems">
      <app-sidebar-item
        [itemTitle]="item.title"
        [iconHostedLocally]="item.iconHostedLocally"
        [iconIdentifier]="item.iconIdentifier"
        [isActive]="item.isActive"
        [displayIf]="item.displayIf"
        [clickAction]="item.clickAction"
      ></app-sidebar-item>
    </ng-template>
  </ul>

  <!-- Need Help? -->
  <div class="card harp-help-card">
    <div class="card-body">
      <h5>Need Help?</h5>
      <p>Contact your application's help desk for assistance.</p>
      <a href="/login/contact"
        >Contact Help Desk <span class="icon ion-md-arrow-round-forward"></span
      ></a>
    </div>
  </div>
</div>
